export const TIPOS_RNTRC = [
	{ value: "ETC", label: "ETC — Empresa de Transporte de Cargas" },
	{ value: "TAC", label: "TAC — Transportador Autônomo de Cargas" },
	{ value: "CTC", label: "CTC — Cooperativa de Transporte de Cargas" },
];
